module.exports = __webpack_public_path__ + "img/Girl_030034.1ceb7fe3.png";